import { useTranslation } from 'react-i18next';

import type { TaskSize, TaskStatus } from '../../../api/types';
import styles from './ReferenceDataTab.module.css';

interface ReferenceDataTabProps {
  taskSizes: TaskSize[];
  taskStatuses: TaskStatus[];
}

// PARA-106, AC-4: read-only справочники task_sizes/task_statuses.
export function ReferenceDataTab({ taskSizes, taskStatuses }: ReferenceDataTabProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div>
      <div className={styles.group}>
        <h2 className={styles.heading}>{t('settings.reference.taskSizes')}</h2>
        <ul className={styles.chips}>
          {taskSizes.map((size) => (
            <li key={size} className={styles.chip}>
              {size}
            </li>
          ))}
        </ul>
      </div>
      <div className={styles.group}>
        <h2 className={styles.heading}>{t('settings.reference.taskStatuses')}</h2>
        <ul className={styles.chips}>
          {taskStatuses.map((status) => (
            <li key={status} className={styles.chip}>
              {status}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
